import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { logoEvent } from './events';
import adminIconGreen from '../../img/admin-icon-green.png';
import adminIcon from '../../img/admin-icon-white.png';
import myComparisonsIcon from '../../img/dashboard-icon-white.png';
import myComparisonsIconGreen from '../../img/dashboard-icon-green.png';
import usersIcon from '../../img/adjusters-icon-white.png';
import usersIconGreen from '../../img/adjusters-icon-teal.png';
import fallbackLogo from '../../img/default-logo.png';

const LeftNavigationPanel = () => {
  const [isActive, setActive] = useState(false);
  const [showModal, setShowModal] = useState(false);

  // Load logo from localStorage if available, otherwise fallback
  const [logoUrl, setLogoUrl] = useState(() => {
    return localStorage.getItem('userLogo') || fallbackLogo;
  });
  const [logoLoaded, setLogoLoaded] = useState(true);

  const userData = useSelector(state => state.user);
  const isAdmin = userData.admin;
  const toggleClass = () => setActive(!isActive);

  // Fetch logo from server
  const fetchLogo = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_GET_LOGO}/${userData._id}`, {
        credentials: 'include',
      });
      const data = await res.json();

      let newLogo = data.logoUrl || fallbackLogo;

      // Only update if different than stored
      const storedLogo = localStorage.getItem('userLogo') || fallbackLogo;
      if (newLogo !== storedLogo) {
        localStorage.setItem('userLogo', newLogo);
        setLogoUrl(newLogo);
      }

      // Track which user the logo belongs to
      localStorage.setItem('logoUserId', userData._id);
    } catch (err) {
      console.error('Logo fetch error:', err.message);
      // Always fallback
      const storedLogo = localStorage.getItem('userLogo') || fallbackLogo;
      if (storedLogo !== fallbackLogo) {
        localStorage.setItem('userLogo', fallbackLogo);
        setLogoUrl(fallbackLogo);
      }
    } finally {
      setLogoLoaded(true);
    }
  };

  // Initial fetch or when user changes
  useEffect(() => {
    if (userData?._id) {
      const storedUserId = localStorage.getItem('logoUserId');
      if (userData._id !== storedUserId) {
        localStorage.removeItem('userLogo');
        setLogoUrl(fallbackLogo);
        setLogoLoaded(false);
        localStorage.setItem('logoUserId', userData._id);
      }
      fetchLogo();
    }
  }, [userData?._id]);

  // Listen for manual refresh events (after logo upload)
  useEffect(() => {
    const handleRefresh = () => {
      localStorage.removeItem('userLogo');
      setLogoUrl(fallbackLogo);
      setLogoLoaded(false);
      fetchLogo();
    };

    logoEvent.addEventListener('refreshLogo', handleRefresh);
    return () => logoEvent.removeEventListener('refreshLogo', handleRefresh);
  }, []);

  const renderAdminLinks = () => {
    const allowedEmails = [
      'jdiem@elkmontllc.com',
      'jdiem@getlevlr.com',
      'dwk2007@gmail.com',
      'jeffdiem2@gmail.com',
      'jeff.diem@gmail.com',
    ];

    const isSuperAdmin =
      (userData.email && allowedEmails.includes(userData.email)) ||
      (userData.email?.includes('@pdgcreative.com') && isAdmin);

    if (isSuperAdmin || isAdmin) {
      return (
        <>
          <li>
            <NavLink
              to="/adminPanel"
              className={({ isActive }) => 'nav-item nav-link' + (isActive ? ' clicked-tab' : '')}
              style={({ isActive }) => ({
                backgroundImage: `url(${isActive ? usersIconGreen : usersIcon})`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: '10% center',
                backgroundSize: '20px auto',
                listStyle: 'none',
                marginBottom: '8px',
                position: 'relative',
              })}
            >
              View Users
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/allComparisons"
              className={({ isActive }) => 'nav-item nav-link' + (isActive ? ' clicked-tab' : '')}
              style={({ isActive }) => ({
                backgroundImage: `url(${isActive ? adminIconGreen : adminIcon})`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: '10% center',
                backgroundSize: '20px auto',
                listStyle: 'none',
                marginBottom: '8px',
                position: 'relative',
              })}
            >
              All Comparisons
            </NavLink>
          </li>
        </>
      );
    }
    return null;
  };

  const renderLeftNav = () => (
    <div className="left-container">
      <div className="elkmont-logo-container">
        {logoLoaded && (
          <NavLink to="/accounts">
            <img
              src={logoUrl}
              onError={(e) => {
                e.currentTarget.src = fallbackLogo;
                localStorage.setItem('userLogo', fallbackLogo);
              }}
              className="elkmont-logo-resize"
              alt="LEVLR Logo"
            />
          </NavLink>
        )}
      </div>

      <nav className="nav-list">
        <ul>
        <li>
          <NavLink
            to="/activeClaims"
            className={({ isActive }) => {
              const noSub =
                !userData?.baseSubscription ||
                (typeof userData.baseSubscription === 'object' &&
                  Object.keys(userData.baseSubscription).length === 0);

              const isAccountsPage = window.location.pathname === '/accounts';
              const flashy = noSub && isAccountsPage ? ' flashy-text' : '';

              return 'nav-item nav-link' + (isActive ? ' clicked-tab' : '') + flashy;
            }}
            style={({ isActive }) => ({
              backgroundImage: `url(${isActive ? myComparisonsIconGreen : myComparisonsIcon})`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: '10% center',
              backgroundSize: '20px auto',
              listStyle: 'none',
              marginBottom: '8px',
              position: 'relative',
            })}
          >
            {(!userData?.baseSubscription ||
              (typeof userData.baseSubscription === 'object' &&
                Object.keys(userData.baseSubscription).length === 0)) &&
            window.location.pathname === '/accounts'
              ? 'Try LEVLR for free!'
              : 'My Comparisons'}
          </NavLink>
        </li>



          {renderAdminLinks()}
        </ul>

        <a
          href="#"
          style={{
            display: 'block',
            marginTop: '16px',
            padding: '12px 24px',
            backgroundColor: '#555555',
            color: '#fff',
            textDecoration: 'none',
            textAlign: 'center',
            fontWeight: 'bold',
          }}
          onClick={(e) => {
            e.preventDefault();
            setShowModal(true);
          }}
        >
          CONTACT <br /> SUPPORT
        </a>

        <a
          href="https://getlevlr.com/support"
          target="_blank"
          style={{
            display: 'block',
            marginTop: '16px',
            padding: '12px 24px',
            backgroundColor: '#555555',
            color: '#fff',
            textAlign: 'center',
            fontWeight: 'bold',
            textDecoration: 'none',
          }}
        >
          VIDEO <br /> KNOWLEDGE BASE
        </a>

        {showModal && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100vw',
              height: '100vh',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              justifyContent: 'center',
              zIndex: 1000,
            }}
            onClick={() => setShowModal(false)}
          >
            <div
              style={{
                backgroundColor: 'white',
                padding: '20px',
                borderRadius: '8px',
                minWidth: '300px',
                textAlign: 'center',
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <h2 style={{ color: '#00B3B5' }}>Contact Support</h2>
              <p style={{ color: '#00B3B5' }}>You can reach us at:</p>
              <strong style={{ color: '#555555' }}>support@getlevlr.com</strong>
              <br />
              <button
                style={{
                  marginTop: '16px',
                  padding: '8px 12px',
                  borderRadius: '4px',
                  cursor: 'pointer',
                }}
                onClick={() => setShowModal(false)}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </nav>

      <style>
        {`
          .clicked-tab {
            color: #399BA5;
            background-color: #DDDEDD;
            border-top-left-radius: 24px;
            border-bottom-left-radius: 24px;
            position: relative;
          }
          .clicked-tab::before,
          .clicked-tab::after {
            content: "";
            position: absolute;
            width: 20px;
            height: 46px;
            right: 0;
          }
          .clicked-tab::before {
            bottom: -46px;
            border-top-right-radius: 24px;
            box-shadow: 0 -23px 0 0 #DDDEDD;
          }
          .clicked-tab::after {
            top: -46px;
            border-bottom-right-radius: 24px;
            box-shadow: 0 23px 0 0 #DDDEDD;
          }
          .nav-item.nav-link {
            color: white;
            display: block;
            text-decoration: none;
          }
          .nav-item.nav-link.clicked-tab {
            color: #399BA5;
          }
        `}
      </style>
    </div>
  );

  return (
    <div>
      <div className={isActive ? 'hamburger' : 'hamburger-change'} onClick={toggleClass}>
        <div className="bar1"></div>
        <div className="bar2"></div>
        <div className="bar3"></div>
      </div>
      {renderLeftNav()}
    </div>
  );
};

export default LeftNavigationPanel;
